module.exports = __webpack_public_path__ + "img/p2.164dea89.png";